import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import MentalHealth from './MentalHealth';

export default function Blog() {
  return (
    <>
        <Navbar />
        <MentalHealth />
        <Footer />
        <Copyright />
    </>
  )
}